import React, { Component, useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter } from "react-router-dom";
import Lenis from "lenis";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Informations from "@/components/Informations";
import Rsvp from "@/components/Rsvp";
import Footer from "@/components/Footer";
import AdminGate from "@/components/AdminGate";
import { setLenis } from "@/lib/lenis";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-sand px-6 text-center">
          <p className="font-serif text-2xl text-taupe">
            Une erreur est survenue — merci de recharger la page.
          </p>
        </div>
      );
    }
    return this.props.children;
  }
}

function App() {
  const [adminOpen, setAdminOpen] = useState(false);

  useEffect(() => {
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce) return undefined;
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    setLenis(lenis);
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <ErrorBoundary>
      <BrowserRouter>
        <div className="relative min-h-screen overflow-x-clip bg-sand text-ink">
          <Navbar onAdminOpen={() => setAdminOpen(true)} />
          <main>
            <Hero />
            <Marquee />
            <Informations />
            <Rsvp />
          </main>
          <Footer onAdminOpen={() => setAdminOpen(true)} />
          <AdminGate open={adminOpen} onClose={() => setAdminOpen(false)} />
        </div>
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;
